import { Component, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BootstrapService } from '../../core/services/bootstrap.service';
import { ModalTypes, ModalActions } from '../../core/enums/base.enums';
import { EscCloseDirective } from '../../core/directives/esc-close.directive';
 
@Component({
  selector: 'ms-info-modal',
  imports: [CommonModule, FontAwesomeModule, EscCloseDirective],
  templateUrl: './info-modal.component.html'
})
 
export class InfoModalComponent {
  public modalId = input<string>();
  public ModalTypes = ModalTypes;
  public modalType = model<ModalTypes>(ModalTypes.Information);

  public title = input<string>();
  public message = model<string | undefined>("");
  public acknowledgeButtonText = input('OK');

  public onConfirm = output();
 
  constructor(private bootstrapService: BootstrapService) {}
 
  public onConfirmClicked(): void {    
    this.bootstrapService.manageModal(`#${this.modalId()}`, ModalActions.Hide);
    this.onConfirm.emit();
  }
}